<div id="users" class="tab-pane fade in active">

  <div style="width:35%;float:left;">

    <h3 class="heading4">Add New User</h3>

    <form #myForm4="ngForm" (submit)="UserCreate();myForm4.reset()">
      <!-- <input name="__RequestVerificationToken" type="hidden" 
        value="dky4LTBI3DDf6x3oFk_ih6JCOwdu3ZNcBJLGLNeS8TQ0BtYDcLCQoTmbTIUTnvPzR_mk3Qvw5xGLGaacsGIlTRISGVR0ajN6WsnhkW7G9d81"> -->

      <div class="form-horizontal">

        <div class="form-group">
          <div class="col-md-10">
            <input class="pagefield text-box single-line" id="User_UserName" [(ngModel)]="UserName" name="UserName"
              placeholder="Enter email ID as User Name"
              style="padding:15px;width:100%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
              type="text" value="" required>

            <span class="field-validation-valid text-danger" data-valmsg-for="UserName"
              data-valmsg-replace="true"></span>
          </div>
          <!-- <div class="col-md-2">
            <button type="button" id="btnSearchUser" class="btn  btn-primary buttonStyle"
              (click)="GetUserDetails(User.UserName)">Search</button>
          </div> -->
        </div>

        <!-- <div class="form-group">
          <div class="col-md-10">
            <input class="pagefield text-box single-line" id="User_Password" [(ngModel)]="User.Password"
              name="Password" placeholder="Enter Password" 
              style="padding:15px;width:100%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;" 
              type="password" value="">
            <span class="field-validation-valid text-danger" data-valmsg-for="User.Password" data-valmsg-replace="true">
            </span>

          </div>
        </div> -->

        <!-- <div class="form-group">
          <div class="col-md-10">
            <input class="pagefield text-box single-line" id="User_samAccountName" [(ngModel)]="User.samAccountName"
              name="samAccountName" placeholder="Account Name"
              style="padding:15px;width:100%;background-color:#F9f9f9 !important;border:none;margin-bottom:8px;"
              type="text" value="" disabled>
            <span class="field-validation-valid text-danger" data-valmsg-for="samAccountName"
              data-valmsg-replace="true">
            </span>

          </div>
        </div> -->
        <br>

        <!-- <div class="form-group">
          <div class="col-md-10">
            <h3 style="font-size:15px;margin:10px 0!important;">Administrator</h3>
            <select class="pagefield list-box tri-state" id="User_IsAdmin" [(ngModel)]="User.IsAdmin" name="IsAdmin" style="width:100px;">
              <option value="true">True</option>
              <option value="false">False</option>
            </select>
            <br>
            <span class="field-validation-valid text-danger" data-valmsg-for="IsAdmin" data-valmsg-replace="true"></span>
          </div>
        </div>
        <br> -->

        <div class="form-group">
          <div class="col-md-10">
            <h3 style="font-size:15px;margin:10px 0!important;">Role</h3>
            <select class="pagefield list-box tri-state" id="User_Role" [(ngModel)]="UserRole" name="Roleid"
              style="width:140px;">
              <option value="1">SuperAdmin</option>
              <option value="2">Admin</option>
              <option value="3">User</option>
            </select>
            <br>
            <span class="field-validation-valid text-danger" data-valmsg-for="Roleid" data-valmsg-replace="true"></span>
          </div>
        </div>
        <br>

        <div class="form-group">
          <div class="col-md-10">
            <h3 style="font-size:15px;margin:10px 0!important;">Select Sector(s) for this User</h3>
            <select class="pagefield" id="SectorList" multiple="multiple" [(ngModel)]="SectorNameList" name="SectorList"
              size="4" style="width:100%">
              <option *ngFor="let sec of sectorlist" value={{sec.SectorName}}>{{sec.SectorName}}</option>
            </select>
            <span class="field-validation-valid text-danger" data-valmsg-for="SectorNames"
              data-valmsg-replace="true"></span>
          </div>
        </div>
        <br>

        <div class="form-group">
          <div class="col-md-10">
            <input type="submit" value="Add User" class="btn btn-lg btn-primary buttonStyle">
          </div>
        </div>

      </div>

    </form>

    <div class="form-group ">

    </div>

  </div>

  <div style="width:55%;float:right;border-left: #eee solid 2px;min-height:600px;padding-left:30px;">
    <br>
    <br>

    <table class="table table-bordered table-hover">

      <thead>
        <colgroup>
          <col width="25%">
          <!-- <col width="25%"> -->
          <col width="25%">
          <col width="25%">
        </colgroup>
      </thead>

      <tbody>
        <tr style="background-color:#F9f9f9;">
          <th>
            <div class="center"><b>Email</b></div>
          </th>
          <!-- <th>
            <div class="center"><b>User Name</b></div>
          </th> -->
          <th>
            <div class="center"><b>Role</b></div>
          </th>

          <!-- <th>
            <div class="center"><b>Is Admin</b></div>
          </th> -->
          <th>
            <div class="center"><b>Mapped Sectors</b></div>
          </th>
          <th>
            <div class="center"><b>Manage</b></div>
          </th>
        </tr>
      </tbody>
      <tbody style="text-align:center;">

        <tr *ngFor="let item of userlist">

          <td>
            {{item.UserName}}
          </td>
          <!-- <td>
            {{item.samAccountName}}
          </td> -->
          <td>
            {{GetRole(item.Roleid)}}
          </td>

          <!-- <td>
            {{item.IsAdmin}}
          </td> -->

          <td>
            {{item.SectorNames}}
          </td>

          <td>
            <a (click)="showEdit(item)" class="modal-link"><span class="glyphicon glyphicon-pencil"
                style="color:#666;"></span></a>&nbsp;&nbsp;
            <a (click)="showConfirm(item)" class="modal-link"><span class="glyphicon glyphicon-trash"
                style="color:#666;"></span></a>
          </td>
        </tr>


      </tbody>

    </table>
  </div>
</div>